// extracted by mini-css-extract-plugin
export default {"wrapper":"Status_wrapper__WY+Cz","noStatus":"Status_noStatus__ycicm","small":"Status_small__zFrwT","mr":"Status_mr__Lgy1S","unknown":"Status_unknown__fs4lB"};